import * as React from 'react';
import { useIntl } from 'react-intl';
import { useRecoilState, useRecoilValue } from 'recoil';
import { ITripsOverviewColumn } from '../interfaces';
import LoaderService from '../../../Services/LoaderService';
import TooltipComponent from '../../TooltipComponent';
import RangeSelectFilter from '../Filter/RangeSelectFilter';
import useFilter from '../hooks/useFilter';
import { getIsColumnLast } from '../TableHeader/TableHeader';
import { AVARAGE_SPEED_KEY, SUFFIX_SPEED } from '../constants';
import { columnsAtom, rideBookFilterAtom } from '../TripsOverviewState';
import { getDataForFilter } from '../TripsOverviewService';
import useAnalytics from '../../../hooks/useAnalytics';

interface IThAvarageSpeedProps {
  id: string;
}

function ThAvarageSpeed(props: IThAvarageSpeedProps): JSX.Element {
  const columnsTable = useRecoilValue<ITripsOverviewColumn[]>(columnsAtom);
  const [tableActionsFilters, setTableActionsFilters] = useRecoilState(
    rideBookFilterAtom(props.id)
  );
  const { formatMessage: f } = useIntl();
  const { updateFilterItemsState } = useFilter();
  const { trackEvent } = useAnalytics();

  const getFilterData = async () => {
    LoaderService.showLoader(true);
    const dataForFilter = await getDataForFilter(AVARAGE_SPEED_KEY);

    if (dataForFilter) {
      updateFilterItemsState([
        { id: props.id, isOpen: true, isActionChipsOpen: false, data: dataForFilter, values: null },
      ]);

      LoaderService.showLoader(false);
    } else {
      LoaderService.showLoader(false);
    }
  };
  const handleOnClick = (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
    event.preventDefault();
    const { id } = event.currentTarget;
    trackEvent(['ride book', 'click', `Ride book open filter ${id}`]);

    setTableActionsFilters(
      (tableActionFilter) =>
        tableActionFilter && {
          ...tableActionFilter,
          id: props.id,
          isOpen: true,
          isActionChipsOpen: false,
        }
    );

    if (id) {
      if (!tableActionsFilters) {
        getFilterData();
      }
    }
  };

  return (
    <div
      className={`th-sticky b-table-actions ${
        tableActionsFilters && tableActionsFilters.values ? 'active' : ''
      }`}
      style={{
        minWidth: '100px',
        flex: 1,
        whiteSpace: 'nowrap',
        cursor: 'pointer',
      }}
    >
      <TooltipComponent
        id={`ridebook-${props.id}`}
        overlay={
          <div style={{ color: '#fff', whiteSpace: 'pre-wrap', fontWeight: 'normal' }}>
            {`${f({
              id: 'tables.tripsOverview.column.avgSpeed',
            })}: `}
            <strong>
              {`${f({
                id: 'tables.tripsOverview.header.tooltip.avgSpeed',
              })}`}
            </strong>
          </div>
        }
        width="300px"
        style={{ top: '35px' }}
        positionLeft={getIsColumnLast(columnsTable, props.id)}
      >
        <div className="d-flex w-100">
          <div
            id={props.id}
            onClick={handleOnClick}
            className="text-truncate"
            data-cy={`filter-button-text-${props.id}`}
          >
            {f({ id: 'tables.tripsOverview.column.avgSpeed' })}
          </div>

          <a
            href="#"
            className="filter cmd-icons cmd-icon-filter"
            id={props.id}
            onClick={handleOnClick}
            data-cy={`filter-button-${props.id}`}
          >
            {/* test */}
          </a>
          <div />
        </div>
      </TooltipComponent>
      {tableActionsFilters &&
        tableActionsFilters.isOpen &&
        !tableActionsFilters.isActionChipsOpen &&
        tableActionsFilters.data && (
          <div id="range-select" style={{ position: 'absolute', left: '0', top: '50px' }}>
            <div className="open">
              <RangeSelectFilter
                id={props.id}
                title={f({ id: 'table_list.columns.rideBook.averageSpeed' })}
                valueFrom={tableActionsFilters.values?.min}
                valueTo={tableActionsFilters.values?.max}
                defaultMinValue={
                  tableActionsFilters.data.minValue ? tableActionsFilters.data.minValue : '0'
                }
                defaultMaxValue={
                  tableActionsFilters.data.maxValue ? tableActionsFilters.data.maxValue : '1000'
                }
                suffix={SUFFIX_SPEED}
              />
            </div>
          </div>
        )}
    </div>
  );
}

export default ThAvarageSpeed;
